import nsMap from '../../assets/episode/nova_scotia_map.svg';
import onMap from '../../assets/episode/ontario_map.svg';
import bcMap from '../../assets/episode/british_columbia_map.svg';
import yukonMap from '../../assets/episode/yukon_map.svg';
import quebecMap from '../../assets/episode/quebec_map.svg';
import albertaMap from '../../assets/episode/alberta_map.svg';
import kia from '../../assets/episode/kia.png';
import trevor from '../../assets/episode/trevor.png';
import wesley from '../../assets/episode/wesley.png';
import bendelacreme from '../../assets/episode/bendelacreme.png';
import dani from '../../assets/episode/dani.png';
import bryan from '../../assets/episode/bryan.png';
import nsVideoLoopD from '../../assets/episode/ns_bg_l.mp4';
import nsVideoLoopT from '../../assets/episode/ns_bg_m.mp4';
import nsVideoLoopM from '../../assets/episode/ns_bg_s.mp4';
import onVideoLoopD from '../../assets/episode/on_bg_l.mp4';
import onVideoLoopT from '../../assets/episode/on_bg_m.mp4';
import onVideoLoopM from '../../assets/episode/on_bg_s.mp4';
import bcVideoLoopD from '../../assets/episode/bc_bg_l.mp4';
import bcVideoLoopM from '../../assets/episode/bc_bg_s.mp4';
import bcVideoLoopT from '../../assets/episode/bc_bg_m.mp4';
import yuVideoLoopD from '../../assets/episode/yu_bg-l.mp4';
import yuVideoLoopM from '../../assets/episode/yu_bg-s.mp4';
import yuVideoLoopT from '../../assets/episode/yu_bg-m.mp4';
import quVideoLoopD from '../../assets/episode/qu-bg-l.mp4';
import quVideoLoopM from '../../assets/episode/qu-bg-s.mp4';
import quVideoLoopT from '../../assets/episode/qu-bg-m.mp4';
import alVideoLoopD from '../../assets/episode/al_bg_l.mp4';
import alVideoLoopM from '../../assets/episode/al_bg_s.mp4';

export const episodeData = [
  {
    id: 'novaScotia',
    episode: 1,
    map: nsMap,
    photo: kia,
    videoD: nsVideoLoopD,
    videoT: nsVideoLoopT,
    videoM: nsVideoLoopM,
    title: 'Nova Scotia',
    link:
      'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/nova-scotia/',
    label: 'Play Episode One, Explore Nova Scotia with Kia Damon',
    play: true,
    name: 'Kia Damon',
    copy:
      'This award-winning chef explores the Mi’kmaq and Acadian cuisine of Nova Scotia – and discovers the soul-healing power of Canada’s maritime regions, with their windswept beauty and welcoming people.'
  },
  {
    id: 'ontario',
    episode: 2,
    map: onMap,
    photo: trevor,
    title: 'Ontario',
    videoD: onVideoLoopD,
    videoT: onVideoLoopT,
    videoM: onVideoLoopM,
    link: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/ontario/',
    label: 'Play Episode two, Explore Ontario with Trevor Wallace',
    play: true,
    name: 'Trevor Wallace',
    copy:
      'This expedition filmmaker and cultural heritage advocate paddles his way through Ontario’s gorgeous parks and natural waterways to explore the significance of the canoe – and discover the uniquely Canadian heritage and spirit which connects the past to the present.'
  },
  {
    id: 'britishColumbia',
    episode: 3,
    map: bcMap,
    photo: wesley,
    title: 'British Columbia',
    videoD: bcVideoLoopD,
    videoT: bcVideoLoopT,
    videoM: bcVideoLoopM,
    link:
      'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/british-columbia/',
    label: 'Play Episode three, Explore British Columbia with Wesley Hamilton',
    play: true,
    name: 'Wesley Hamilton',
    copy:
      'This entrepreneur and advocate finds freedom in the wild views and craggy peaks of British Columbia ⁠— and explores the power of decompression, relaxation, and uniquely enriching Canadian experiences.'
  },
  {
    id: 'yukon',
    episode: 4,
    map: yukonMap,
    photo: bendelacreme,
    title: 'Yukon',
    videoD: yuVideoLoopD,
    videoT: yuVideoLoopT,
    videoM: yuVideoLoopM,
    link: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/yukon/',
    label: 'Play Episode four, Explore Yukon with Bendelacreme',
    play: true,
    name: 'Bendelacreme',
    copy:
      'Travel north with BenDeLaCreme, an award-winning Drag Performer and LGBTQIA+ advocate, as she explores the breathtaking landscapes of the Canadian Yukon—a wild and wonderful place infused with rich art, history, and culture.',
    disclaimer:
      'Filmed at the Palace Grand Theatre, Klondike National Historic Sites, with the permission of Parks Canada'
  },

  {
    id: 'quebec',
    episode: 5,
    map: quebecMap,
    photo: bryan,
    title: 'Québec',
    videoD: quVideoLoopD,
    videoT: quVideoLoopT,
    videoM: quVideoLoopM,
    link: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/quebec/',
    label: 'Play Episode five, Explore Québec with Bryan Ford',
    play: true,
    name: 'Bryan Ford',
    copy:
      'This baker, author, and podcaster explores human connection and history by baking breads from different cultures around the world. As Bryan journeys through Québec, literally breaking bread with its artisans, chefs, and knowledge-keepers, he discovers what truly nourishes them and brings meaning to the place they call home.'
  },
  {
    id: 'alberta',
    episode: 6,
    map: albertaMap,
    photo: dani,
    title: 'Alberta',
    videoD: alVideoLoopD,
    videoT: alVideoLoopM,
    videoM: alVideoLoopM,
    // date: 'AUGUST 2024',
    link: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/alberta/',
    label: 'Play Episode six, Explore Alberta with Dani Reyes-Acosta',
    play: true,
    name: 'Dani Reyes-Acosta',
    copy:
      'This consummate outdoor athlete is known for her backcountry skills and her partnership with organizations around the world that focus on conservation and climate regeneration. Together with Dani we experience the majestic and awe-inspiring winter of Alberta, Canada.'
    // disclaimer: 'Photo by Leslie Hittmeier for OUTLIER Trust'
  },
  {
    id: 'wideOpenCountry',
    episode: 7,
    title: 'A Wide Open Country',
    copy:
      'Inspired by our films? Get a jumpstart on your own journey up north – and see how Canada has something for everybody.',
    button: 'read article',
    label: 'Read article, Canada: A Wide Open Country',
    link: 'https://sponsorcontent.cnn.com/interactive/destination-canada/wide-open-country/'
  }
];
